import staffTraining from "./pictures/staff-training.jpg";
import engineeringSupport from "./pictures/engineering-support.jpg";
import repair from "./pictures/repair.jpg";
import cemLife from "./pictures/cem-life.png";
import cemLifeRealTime from "./pictures/cemlife-realtime.png";
import cemTest from "./pictures/cem-test.png";
import drillingSolutions from "./pictures/drilling-solutions.png";
import valve from "./pictures/valve.png";
import trueSight from "./pictures/true-sight.png";
import cemHeads from "./pictures/cem-heads.png";

export interface ProductItem {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  imageFit?: "cover" | "contain";
  direction?: "row" | "column";
}

export interface ProductGroup {
  id: string;
  title: string;
  products: ProductItem[];
}

export const productsContent: {
  title: string;
  intro: string;
  groups: ProductGroup[];
} = {
  title: "Продукты",
  intro:
    "ООО “ИРТ” предлагает комплексные решения для инженерного планирования, сооружения и обслуживания нефтегазовых скважин. Мы адаптируем технологии к геологии Ваших месторождений.",
  groups: [
    {
      id: "services",
      title: "Услуги",
      products: [
        {
          slug: "staff-training",
          title: "Обучение персонала",
          subtitle: "Курсы повышения квалификации",
          description:
            "ООО “ИРТ” проводит экспертное обучение для повышения квалификации персонала. Наша компания имеет образовательную лицензию и осуществляет обучение по нескольким направлениям.",
          image: staffTraining,
        },
        {
          slug: "engineering-support",
          title: "Инженерное сопровождение",
          subtitle: "Инженерные расчеты любой сложности",
          description:
            "Наши инженеры — высококлассные специалисты с опытом работы в ведущих сервисных компаниях, которые могут предоставить расчеты и инженерные решения для любой задачи.",
          image: engineeringSupport,
        },
        {
          slug: "repair-and-insulation",
          title: "Ремонтно-изоляционные работы",
          subtitle: "На уровне пласта и на устье скважины",
          description:
            "Мы проводим ремонтно-изоляционные работы на уровне пласта и на устье скважины. В работе используются полимерные смолы с высокой эластичностью и прочностью.",
          image: repair,
        },
      ],
    },
    {
      id: "software",
      title: "Программное обеспечение",
      products: [
        {
          slug: "cemlife",
          title: "CemLife",
          subtitle: "Планирование цементирования",
          description:
            "Программное обеспечение для расчетов при цементировании. Позволяет снизить риск инцидентов при сооружении нефтегазовых скважин.",
          image: cemLife,
        },
        {
          slug: "cemlife-realtime",
          title: "CemLife Realtime",
          subtitle: "Контроль цементирования",
          description:
            "Программное обеспечение для контроля процесса цементирования в реальном времени помогает отслеживать положение жидкостей и вероятность возникновения инцидента.",
          image: cemLifeRealTime,
        },
        {
          slug: "cemtest",
          title: "CemTest",
          subtitle: "Автоматизированная лаборатория",
          description:
            "Информационная система для автоматизации процессов в лабораториях, занимающихся тампонажными растворами.",
          image: cemTest,
        },
        {
          slug: "drilling-solutions",
          title: "Drilling Solutions",
          subtitle: "Сопровождение скважин",
          description:
            "Программный комплекс для инженерного проектирования, гидравлических расчетов и моделирования процессов бурения и заканчивания нефтяных и газовых скважин.",
          image: drillingSolutions,
        },
      ],
    },
    {
      id: "equipment",
      title: "Оборудование",
      products: [
        {
          slug: "reverse-cementing-valve",
          title: "Клапан для обратного цементирования",
          subtitle: "Управляемый обратный поток жидкости",
          description:
            "Технологическое решение, обеспечивающее управляемый обратный поток жидкости при цементировании и позволяющее выполнять операции с устья без применения стандартной оснастки.",
          image: valve,
          imageFit: "contain",
          direction: "row",
        },
        {
          slug: "true-sight",
          title: `Лабораторное оборудование \nTrue Sight`,
          subtitle: "Тестирование цементного камня",
          description:
            "Наиболее точная технология тестирования цементного камня в отрасли, отражающая его действительные свойства в реальных скважинных условиях.",
          image: trueSight,
          imageFit: "contain",
          direction: "row",
        },
        {
          slug: "rotating-cementing-heads",
          title: `Цементировочные головы \nс вращением`,
          subtitle: "Устьевое оборудование",
          description:
            "Устьевое оборудование для безопасного вращения обсадной колонны во время цементирования и повышения качества замещения бурового раствора.",
          image: cemHeads,
          imageFit: "contain",
          direction: "row",
        },
      ],
    },
  ],
};
